export const environment = {
  production: true,
  oauth_id: 'DFCE1imiTddXQvFfIVf0D5wuhNeVq8DUSlBQWs23',
  oauth_secret: 'mBxiABY2mZmIUbn8Ds2qNzrZJP0OjZ5N3AmNIUXjNixmDeeS10msbHmZkj4lhoqQqgs6psyasbRdd4ffokAv09otKaWXjoXagBjpGMWpwWznEix3y8hnQzeMMMkK4j5B',
  url: 'https://boris-api.workis.lt',
  livasAPIBase: 'https://livas.biuro.lt',
  livasAPIBaseLT: 'https://livas.biuro.lt/',
  livasAPIBaseLV: 'https://livas.biuro.lv/',
  livasAPIBaseEE: 'https://livas.biuro.ee/',
  // relative: each instance serves all countries; call whichever embedded the iframe
  livasAPIBaseLTV3: '/lt/jobs/api/v3',
  livasAPIBaseLVV3: '/lv/jobs/api/v3',
  livasAPIBaseEEV3: '/ee/jobs/api/v3',
  livasAPIBaseGiGroupV3: '/gi-group/jobs/api/v3',
  edlaAPIBase: 'https://livas.biuro.lt',
  env: 'prod',
  googleMapsApiKey: 'AIzaSyAYdYFM5OLlhA1teNMLZYFfz-EISrSZkY4'
};
